module.exports = __webpack_public_path__ + "static/4-290329414baff7c89874b195c413a3bb.png";